import { render, staticRenderFns } from "./ProfileLanguage.vue?vue&type=template&id=2e4c1957"
import script from "./ProfileLanguage.vue?vue&type=script&lang=js"
export * from "./ProfileLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports